import type { ConnectResult, OutlookStatus } from '../../../src/shared/types';
import { calendarAccounts, forgetCalendarAccounts, startCalendarConnect } from '../calendarAccounts';

/**
 * `microsoftAuth.ts`'nin web karşılığı: Outlook takvim yetkisi sunucuda
 * (bkz. calendarAccounts.ts).
 */

export class MicrosoftAuthError extends Error {
  constructor(public readonly code: 'not_connected' | 'auth_expired' | 'network') {
    super(code);
    this.name = 'MicrosoftAuthError';
  }
}

export async function getMicrosoftAccessToken(): Promise<string> {
  throw new MicrosoftAuthError('not_connected');
}

export async function getOutlookStatus(): Promise<OutlookStatus> {
  const { microsoft } = await calendarAccounts();
  return {
    configured: microsoft.configured,
    connected: microsoft.connected && !microsoft.expired,
    expired: microsoft.expired || undefined,
    profile: microsoft.profile,
  };
}

/** Çıkışta ve hesap silmede: yalnızca önbellek (bkz. googleAuth.ts > disconnectGoogle). */
export async function disconnectMicrosoft(): Promise<void> {
  forgetCalendarAccounts();
}

export async function connectMicrosoft(): Promise<ConnectResult> {
  // Web'de sayfa Microsoft'a gidiyor; buraya yalnızca hata (ya da mobilde dönüşsüz kapanan tarayıcı) düşer.
  return startCalendarConnect('microsoft').catch((err: unknown) => ({ ok: false, error: (err as Error).message }));
}
